import Swal from "sweetalert2";

export function focusFirstError(errors) {
  if (!errors || typeof errors !== "object") return;

  const firstKey = Object.keys(errors)[0];
  const message = errors[firstKey];

  if (!firstKey || !message) return;

  scrollToField(firstKey, message);
}

function scrollToField(fieldName, message) {
  const el =
    document.querySelector(`[name="${fieldName}"]`) ||
    document.querySelector(
      `[name="${fieldName.replace(/\[/g, "\\[").replace(/\]/g, "\\]")}"]`
    );

  if (el) {
    setTimeout(() => {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      if (el.tagName !== "DIV") {
        el.focus({ preventScroll: true });
      }
    }, 100);
  } else {
    console.warn("No se encontró el campo:", fieldName);
  }

  Swal.fire({
    toast: true,
    icon: "warning",
    title: message,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });
}
